module.exports = {
	"title": {
		"artist": "Qobuzで {artistName} を聴く",
		"album": "{artistName}の{albumName}をQobuzで聴く",
		"track": "{artistName}の{trackName}をQobuzで聴く",
		"playlist": "{ownerName}の{playlistName}をQobuzで聴く",
		"story": "Qobuzに関するこの記事を読む"
	},
	"buttons": {
		"listen": "Qobuzで聴く",
		"buy": "購入",
		"share": "シェアする",
		"download": "無料で試す",
		"readmore": "もっと読む",
		"showless": "詳細を閉じる",
		"showmore": "もっと見る",
		"morealbums": "Qobuzで他のアルバムを見る",
		"moreplaylisttrack": "Qobuzで他の作品を発見する",
		"readfocus": "このパノラマをQobuzで読む",
		"seeSubscribes": "サブスクリプションオファーを見る",
		"cookies": "Cookie設定"
	},
	"infos": {
		"trackCount": "{count}曲",
		"label": "レーベル：{label}",
		"composer": "作曲者：{composer}",
		"producers": "制作",
		"mixers": "ミックス／マスタリング",
		"diskCount": "{count}アルバム",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "非公開",
			"public": "公開"
		},
		"hires": "高音質",
		"available": "利用可能"
	},
	"share": {
		"twitter": {
			"track": "{artist}の{title}をQobuzで聴く",
			"album": "{artist}の{title}をQobuzで聴く",
			"artist": "Qobuzで{artist}を聴く",
			"playlist": "{owner}の{playlist}をQobuzで聴く",
			"story": "Qobuzでこの記事を読む"
		},
		"mail": {
			"track": {
				"subject": "{artist}の{title}をQobuzでお楽しみいただけます！",
				"body": "{artist}の{title}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"album": {
				"subject": "{artist}の{title}がQobuzでご利用できます！",
				"body": "{artist}の {title}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"artist": {
				"subject": "{artist}がQobuzで聴けます！",
				"body": "{artist}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"playlist": {
				"subject": "{owner}の{playlist}がQobuzでご利用できます！",
				"body": "{owner}の{playlist}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "{url}を読むには\n\nQobuzは、高音質ストリーミングとダウンロードのパイオニアサービスです。\n詳細と登録はQobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "クリックでコピー",
			"copy": "コピー",
			"copied": "コピーされました",
			"link": "シェアするには以下のリンクをコピーしてください"
		}
	},
	"tracklist": {
		"title": {
			"track": "曲",
			"album": "アルバム曲",
			"artist": "トップ曲",
			"artist_albums": "アルバム",
			"playlist": "プレイリストの曲"
		},
		"header": {
			"number": "#",
			"name": "曲",
			"album": "アルバム",
			"artist": "アーティスト",
			"time": "再生時間",
			"label": "レーベル"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "利用可能な楽曲はありません"
	},
	"story": {
		"404": {
			"title": "リクエストされたアイテムは、お住まいの地域には存在しません。",
			"description": "Qobuzマガジンのホームに戻る"
		},
		"from": "セレクト {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Qobuz に参加して記事全文を読む...",
		"signUp": "無料でお試しください"
	},
	"playlist": {
		"from": "セレクト {author}"
	},
	"album": {
		"by": "par",
		"publishedBy": "のリリース"
	},
	"notifications": {
		"nostream": "権利者の都合により、この曲の試聴はできません"
	},
	"aside": {
		"title": "詳細"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/ja.json
// module id = 570
// module chunks = 0